@import '@helsenorge/designsystem-react/scss/_palette.scss';
@import '../../styles/utilities/text.scss';

.referenceblock {
  &__control {
    background-color: $neutral900;

    &:hover,
    &:focus {
      background-color: $neutral800;
    }

    &:focus {
      @extend .underline-text;
      outline: 4px solid $black;
      text-decoration-color: $white;
    }
  }
}
